import React from "react";
import "./style.css";
import HamburgerMenu from "./HamburgerMenu";

const Header = ({ isOpen, setIsOpen, ucarSerchData }) => {
  return (
    <div className='header'>
      <div className='headerlogocorpo'>
        <div className='headerlogo'>
          <a href='https://shiga.corolla-dealer.jp/' className='logo'>
            <img
              className='ucarboothlogo'
              src={`${process.env.PUBLIC_URL}/ucarbooth.svg`}
              alt='UCAR BOOTH'
            />
          </a>
        </div>
        <div className='headercorpo'>
          <a href='https://shiga.corolla-dealer.jp/' className='logo'>
            <img
              className='coroshigalogo'
              src={`${process.env.PUBLIC_URL}/UBOOTH.svg`}
              alt='カローラ滋賀ロゴ'
            />
          </a>
        </div>
        <div className='ucarDaisu'>検索台数: {ucarSerchData.length}台</div>
      </div>

      <HamburgerMenu isOpen={isOpen} setIsOpen={setIsOpen} />
    </div>
  );
};

export default Header;
